export function decodeToken(token: string): any | null {
    try {
        const payload = JSON.parse(window.atob(token.split('.')[1]));
        return payload as any;
    } catch (e) {
        return null;
    }
}
